import Immutable from 'immutable';
import reducerCreator from '../../tools/reducer-creator';
import * as types from '../../actions/vacancies/vacancy-documents/types';

const initialState = Immutable.fromJS({
  isFormLoading: false,
  documents: undefined,
  newVacancyDocument: null,
  isDocumentAdding: false,
  isDocumentRemoving: false,
  isDocumentUpdating: false
});

export default reducerCreator(initialState, {
  [types.VACANCY_DOCUMENTS_SET_FORM_LOADING]: (state, { isFormLoading }) =>
    state.set('isFormLoading', isFormLoading),

  [types.VACANCY_DOCUMENTS_SET_VACANCY_DOCUMENTS]: (state, { documents }) =>
    state.set('documents', documents),

  [types.VACANCY_DOCUMENTS_SET_NEW_VACANCY_DOCUMENT]: (state, { vacancyDocument }) =>
    state.set('newVacancyDocument', vacancyDocument),

  [types.VACANCY_DOCUMENTS_SET_DOCUMENT_ADDING]: (state, { isDocumentAdding }) =>
    state.set('isDocumentAdding', isDocumentAdding),

  [types.VACANCY_DOCUMENTS_SET_DOCUMENT_REMOVING]: (state, { isDocumentRemoving }) =>
    state.set('isDocumentRemoving', isDocumentRemoving),

  [types.VACANCY_DOCUMENTS_SET_DOCUMENT_UPDATING]: (state, { isDocumentUpdating }) =>
    state.set('isDocumentUpdating', isDocumentUpdating),

  [types.VACANCY_DOCUMENTS_RESET_STATE]: () => initialState
});



// WEBPACK FOOTER //
// ./src/reducers/vacancies/vacancy-documents.js